import axios from 'axios'
import config from '../config'
import qs from "qs";

export default {

    getSpamEmailsList(currentPage, perPage, search) {
        return axios.get(config.publicPath + 'spam_emails', {
            params: {_page: currentPage, itemsPerPage: perPage, 'email.email': search},
            paramsSerializer: qs.stringify,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    },
    addSpamEmails(formData) {
        return axios.post(config.publicPath + 'add-spam-emails', formData, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            validateStatus: function (status) {
                return status >= 200 && status < 500;
            },
        });
    },
    addSpamEmail(postData) {
        return axios.post(config.publicPath + 'add-spam-email', postData, {
            headers: {
                'Content-Type': 'application/json'
            },
            validateStatus: function (status) {
                return status >= 200 && status < 500;
            }
        });
    },
    getSpamEmail(id) {
        return axios.get(config.publicPath + 'spam_emails/' + id);
    },
    deleteSpamEmail(id) {
        return axios.post(config.publicPath + 'remove-spam-email', {emailId: id}, {
            headers: {
                'Content-Type': 'application/json'
            },
            validateStatus: function (status) {
                return status >= 200 && status < 500;
            }
        });
    }
}
